// İl seçerek görüntüleme
//
// Türkiye geneli yetkisi olan kullanıcılar (admin, disiplin kurulu) panelin üst
// çubuğundan bir il seçebilir. Seçim bu tarayıcıda saklanır ve her API isteğine
// X-Acting-City başlığı olarak eklenir; sunucu o istek boyunca kullanıcıyı
// seçilen ilin yetkilisi gibi kapsamlar (listeler o ile süzülür, il gerektiren
// ekranlar o ili kullanır). Yetkiler değişmez, yalnızca kapsam daralır.
// İl kısıtlı rollerde başlık sunucuda yok sayılır.
import { isNationwideRole } from "./roleManagement";

export const ACTING_CITY_KEY = "actingCity";
export const ACTING_CITY_HEADER = "X-Acting-City";

export const readActingCity = () => {
  if (typeof window === "undefined") return null;
  try {
    const value = JSON.parse(localStorage.getItem(ACTING_CITY_KEY) || "null");
    const id = Number(value?.id);
    if (!Number.isInteger(id) || id <= 0) return null;
    return { id, name: String(value.name || "") };
  } catch {
    return null;
  }
};

export const writeActingCity = (city) => {
  try {
    if (city?.id) localStorage.setItem(ACTING_CITY_KEY, JSON.stringify({ id: Number(city.id), name: city.name || "" }));
    else localStorage.removeItem(ACTING_CITY_KEY);
  } catch {
    /* özel pencere: seçim saklanamaz */
  }
};

export const clearActingCity = () => writeActingCity(null);

/** İsteğe eklenecek başlık değeri (seçim yoksa null). */
export const actingCityHeaderValue = () => {
  const city = readActingCity();
  return city ? String(city.id) : null;
};

/**
 * Oturumdaki kullanıcıyı seçilen ilin yetkilisi gibi gösterir: city seçilen
 * il olur, kayıtlı il homeCity'de durur. Türkiye geneli olmayan kullanıcıda
 * seçim geçersizdir ve kullanıcı olduğu gibi döner.
 */
export const withActingCity = (user, acting = readActingCity()) => {
  if (!user || !acting || !isNationwideRole(user.role)) return user;
  return { ...user, city: acting.name, homeCity: user.city ?? null, actingCity: acting };
};
